<template>
    <div class="content">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'Content'
}
</script>

<style>
    .content {
        z-index: 1;
        background-color: #f7f0f1;
        margin: 0;
    }
</style>